export default __webpack_public_path__ + "static/media/Personaliza-tu-seguro.1329010f.svg";